var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiked = function SvgLiked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Liked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.521 1.433-.896.886-.791.782.791.782.791-.782.896-.885a2.988 2.988 0 0 1 2.1-.86c.787 0 1.543.31 2.1.86.557.55.87 1.297.87 2.076 0 .778-.313 1.525-.87 2.076l-5.887 5.819-5.886-5.82a2.919 2.919 0 0 1-.87-2.075c0-.779.313-1.525.87-2.076a2.987 2.987 0 0 1 2.1-.86c.787 0 1.543.31 2.1.86l.18.178.791-.781-.18-.179A4.113 4.113 0 0 0 4.837.25a4.113 4.113 0 0 0-2.89 1.184A4.018 4.018 0 0 0 .75 4.292c0 1.071.43 2.1 1.197 2.857l6.678 6.601 6.677-6.6A4.018 4.018 0 0 0 16.5 4.291c0-1.072-.43-2.1-1.197-2.858A4.112 4.112 0 0 0 12.413.25 4.112 4.112 0 0 0 9.52 1.433Z",
    fill: "#EE9000",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.625 3.883-.791-.782-.715-.707-.18-.178a2.987 2.987 0 0 0-2.1-.86c-.788 0-1.543.31-2.1.86a2.919 2.919 0 0 0-.87 2.076c0 .778.313 1.525.87 2.076l5.886 5.819 5.887-5.82c.557-.55.87-1.297.87-2.075 0-.779-.313-1.525-.87-2.076a2.987 2.987 0 0 0-2.1-.86c-.788 0-1.543.31-2.1.86l-.896.885-.79.782Z",
    fill: "#EE9000",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.834 3.101.791-.782-.715-.706-.791.781.715.707Z",
    fill: "#EE9000",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.521 1.433 7.834 3.101l.791.782 1.687-1.667a2.988 2.988 0 0 1 2.1-.86c.787 0 1.543.31 2.1.86.557.55.87 1.297.87 2.076 0 .778-.313 1.525-.87 2.076l-5.887 5.819-5.886-5.82a2.919 2.919 0 0 1-.87-2.075c0-.779.313-1.525.87-2.076a2.987 2.987 0 0 1 2.1-.86c.787 0 1.543.31 2.1.86l.18.178.791-.781-.18-.179A4.113 4.113 0 0 0 4.837.25a4.113 4.113 0 0 0-2.89 1.184A4.018 4.018 0 0 0 .75 4.292c0 1.071.43 2.1 1.197 2.857l6.678 6.601 6.677-6.6A4.018 4.018 0 0 0 16.5 4.291c0-1.072-.43-2.1-1.197-2.858A4.112 4.112 0 0 0 12.413.25 4.112 4.112 0 0 0 9.52 1.433Z",
    fill: "#684D3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Liked_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75 .25)",
    d: "M0 0h15.75v13.5H0z"
  })))));
};
export default SvgLiked;